import { JamEventStatusForSidebar } from '@/src/types/JamChallengeDetails';
import { JamEventStatus } from '@/src/types/JamCommon';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { Box, Icon } from '@amzn/awsui-components-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface TaskStatusProps {
  taskCompleted?: boolean;
  taskLocked?: boolean;
  name?: JamEventStatusForSidebar;
  status?: JamEventStatus | undefined;
  challengeStatus?: boolean | undefined;
}

const TaskStatus: React.FC<TaskStatusProps> = ({ taskCompleted, taskLocked, name, status, challengeStatus }) => {
  const { t } = useTranslation();

  // Facilitator-agnostic: icon reflects the caller-supplied props, consistent with the caller's navigability decision.
  const className =
    name === JamEventStatusForSidebar.LOCKED || taskLocked || !challengeStatus
      ? 'status-INCOMPLETE'
      : name === JamEventStatusForSidebar.SOLVED || taskCompleted
      ? 'status-COMPLETE'
      : '';
  return (
    <Box variant="span" className={className}>
      {taskCompleted || name === JamEventStatusForSidebar.SOLVED ? (
        <Icon
          name="status-positive"
          ariaLabel={t(i18nKeys.general.complete)}
          variant="success"
          data-testid="task-solved"
        />
      ) : taskLocked ||
        name === JamEventStatusForSidebar.LOCKED ||
        status === JamEventStatus.ENDED ||
        !challengeStatus ? (
        <Icon name="lock-private" ariaLabel={t(i18nKeys.general.locked)} variant="warning" data-testid="task-locked" />
      ) : (
        // Unlocked but not solved: subtle icon, consistent with the challenge-level status icons.
        <Icon
          name="status-not-started"
          ariaLabel={t(i18nKeys.general.inProgress)}
          variant="subtle"
          data-testid="task-in-progress"
        />
      )}
    </Box>
  );
};

export default TaskStatus;
